/* Quetzal content-page motion: scroll reveals, stat count-up, hero parallax.
   Only runs when layout/theme.liquid added the `qz-motion` class to <html>
   (skipped for reduced-motion users and inside the theme editor). If this
   file fails to load, the inline fallback removes the class so nothing
   stays hidden. */
(() => {
  window.qzMotionReady = true;
  const root = document.documentElement;
  if (!root.classList.contains('qz-motion')) return;

  const SELECTOR = [
    '.qz__inner > .qz__title', '.qz__inner > .qz__lede', '.qz__inner > .qz-rte', '.qz__inner > .qz__actions',
    '.qz-hero__grid > *', '.qz-card', '.qz-pcard', '.qz-plan', '.qz-quote', '.qz-feature', '.qz-stats li',
    '.qz-logos li', '.qz-integration', '.qz-dark-feature__list li', '.qz-dark-feature__media', '.qz-facts__row',
    '.qz-faq details', '.qz-customers li', '.qz-table-wrap', '.qz-verdict__card', '.qz-tour', '.qz-press',
    '.qz-callout', '.qz-note',
  ].join(',');

  const els = Array.from(document.querySelectorAll(SELECTOR));
  els.forEach((el) => {
    const siblings = Array.from(el.parentElement.children).filter((c) => c.matches(SELECTOR));
    el.style.setProperty('--qz-i', Math.min(siblings.indexOf(el), 5));
  });

  const countUp = (li) => {
    const el = li.querySelector('.qz-stats__value');
    const m = el && el.textContent.trim().match(/^(\D*)([\d,]+)(.*)$/);
    if (!m) return;
    const end = parseInt(m[2].replace(/,/g, ''), 10);
    if (!end) return;
    const fmt = (n) => m[1] + n.toLocaleString('en-US') + m[3];
    const start = performance.now();
    const duration = 1200;
    const step = (now) => {
      const p = Math.min((now - start) / duration, 1);
      el.textContent = fmt(Math.round(end * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(step);
    };
    el.textContent = fmt(0);
    requestAnimationFrame(step);
  };

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        io.unobserve(el);
        el.classList.add('is-visible');
        if (el.matches('.qz-stats li')) countUp(el);
        const delay = 900 + (parseInt(el.style.getPropertyValue('--qz-i'), 10) || 0) * 80;
        setTimeout(() => el.classList.add('is-done'), delay);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0 }
  );
  els.forEach((el) => io.observe(el));

  // Gentle parallax on the photo hero (desktop only).
  const media = document.querySelector('.qz-photo-hero__media');
  if (media && window.matchMedia('(min-width: 990px)').matches) {
    const hero = media.parentElement;
    let ticking = false;
    const update = () => {
      ticking = false;
      if (hero.getBoundingClientRect().bottom < 0) return;
      media.style.transform = `translate3d(0, ${window.scrollY * 0.18}px, 0)`;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
  }
})();
